import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'src/ui/library/styled';
import PropTypes from 'prop-types';
// import ButtonComponent from 'src/new-ui/library/ButtonComponent/ButtonComponent';
// import printIcon from '../../../../assets/dashboardIcons/printIcon.png';

const styles = () => ({
  noteText: {
    fontSize: '12px',
    fontFamily: 'EYInterstate-Light',
    color: '#747480',
  },
});

const CaseDataPageFooter = ({ classes, children }) => {
  return (
    <Grid container className="align-items-center">
      <Grid item lg={5} md={5} sm={3}>
        <span className={classes.noteText}>Note: No changes can be made after this page is submitted</span>
      </Grid>
      <Grid item lg={7} md={7} sm={9}>
        {children}
      </Grid>
    </Grid>
  );
};

CaseDataPageFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default styled(CaseDataPageFooter)(styles);
